<div class="add-edit-form-skeleton common-border-radius">
  <div class="common-background-color px-3 sticky-header add-edit-form-skeleton__header mi-form-header" *ngIf="tabs.length">
    <div class="mi-tabs grid m-0 pt-2">
      <div class="col-6 flex p-0 gap-3 align-items-center">
        <span class="mi-tabs-item add-edit-form-skeleton__tab" *ngFor="let _ of tabs">
          <p-skeleton width="5.5rem" height="1.25rem"></p-skeleton>
        </span>
      </div>
      <div class="col-6 flex justify-content-end gap-2 p-0 pb-2">
        <div class="w-full flex justify-content-end align-items-center gap-2">
          <p-skeleton width="5.5rem" height="2.05rem" borderRadius="5px"></p-skeleton>
          <p-skeleton width="5.5rem" height="2.05rem" borderRadius="5px"></p-skeleton>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 scroll-bar-css generic-form-container add-edit-form-skeleton__body mi-form-scroll">
    <div class="flex flex-column gap-3">
      <div class="mi-section-block common-background-color border-radius-5px" *ngFor="let _ of sections">
        <div class="mi-section-title">
          <p-skeleton width="10rem" height="1.25rem"></p-skeleton>
        </div>
        <div class="w-full grid">
          <div class="form-field" [ngClass]="fieldColsClass" *ngFor="let __ of fields">
            <div class="form-label">
              <p-skeleton width="60%" height="1rem"></p-skeleton>
            </div>
            <div class="form-control">
              <p-skeleton width="100%" height="33px" borderRadius="6px"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
